'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = mapStateToProps;
exports.Tracking = Tracking;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _filters = require('../helpers/filters');

var _query = require('../helpers/query');

var _ThirdPartyTags = require('../components/ThirdPartyTags');

var _ThirdPartyTags2 = _interopRequireDefault(_ThirdPartyTags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mapStateToprops can be either an object or a funciton
function mapStateToProps(state, ownProps) {
  return {
    loaded: state.reduxAsyncConnect.loaded,
    location: ownProps.location,
    params: ownProps.params,
    hotels: state.hotels,
    req: state.httpRequest.req,
    search: state.search
  };
}

function Tracking(props) {
  var loaded = props.loaded,
      location = props.location,
      params = props.params,
      hotels = props.hotels,
      req = props.req,
      search = props.search;


  var matched = req.host.match(/^travel.rakuten.(.+)$/);
  var data = {};

  data.domain = matched ? matched[1] : '';
  data.user = {
    device: req.useragent.isMobile ? 'sp' : 'pc'
  };

  var query = location && location.query ? location.query : location && location.href ? (0, _urlParse2.default)(location.href, true).query : {};
  var pathname = location ? location.pathname : '';
  var dated = query.checkin && query.checkout;
  var hotelNos = [];

  // TODO: order is important to match URI correctly
  //       better to have good matching logic.
  // spot
  if (/^\/hotellist\/[^\-]+\-[^\-]+\-[^\-]+\-/.test(pathname)) {
    data.contents = {
      repository: 'm17n',
      type: 'hotel'
    };
    data.page = {
      id: '28',
      type: 'search',
      name: 'm17nspot',
      sc: 'search:spot' + (dated ? '_dated' : '')
    };

    // area
  } else if (/^\/hotellist\/[^\-]+\-[^\-]+\-/.test(pathname)) {
    data.contents = {
      repository: 'm17n',
      type: 'hotel'
    };
    data.page = {
      id: '27',
      type: 'search',
      name: 'm17narea',
      sc: 'search:area' + (dated ? '_dated' : '')
    };

    // country
  } else if (/^\/hotellist\/[^\-]+/.test(pathname)) {
    data.contents = {
      repository: 'm17n',
      type: 'hotel'
    };
    data.page = {
      id: '26',
      type: 'search',
      name: 'm17ncountry',
      sc: 'search:area' + (dated ? '_dated' : '')
    };

    // hotel
  } else if (/^\/hotel\//.test(pathname)) {
    data.contents = {
      repository: 'm17n',
      type: 'hotel'
    };
    data.page = {
      id: '29',
      type: 'product',
      name: 'm17nhotel',
      sc: 'hotel:top' + (dated ? '_dated' : '')
    };
    var splitted = pathname.split('/');
    splitted.pop();
    hotelNos.push(splitted.pop());

    // step1
  } else if (/^\/booking\/guestinfo/.test(pathname)) {
    data.contents = {
      repository: 'm17n',
      type: 'hotel'
    };
    data.page = {
      id: '30',
      type: 'booking_step',
      name: 'm17nbook1'
    };

    // step2
  } else if (/^\/booking\/payment/.test(pathname)) {
    data.contents = {
      repository: 'm17n',
      type: 'hotel'
    };
    data.page = {
      id: '31',
      type: 'booking_step',
      name: 'm17nbook2'
    };

    // complete
  } else if (/^\/booking\/complete/.test(pathname)) {
    data.contents = {
      repository: 'm17n',
      type: 'hotel'
    };
    data.page = {
      id: '32',
      type: 'booking_complete',
      name: 'm17nbook3'
    };

    // top
  } else if (/^\/$/.test(pathname)) {
    data.contents = {
      repository: 'm17n',
      type: 'common'
    };
    data.page = {
      id: '',
      type: 'home',
      name: 'm17ntop'
    };
  }
  data.query = {
    items: _lodash2.default.times(search.rooms || 0, function () {
      return {
        from: {
          country: search.country,
          prefecture: search.subdivision,
          city: search.city,
          spot: search.spot,
          date: (0, _query.convertStayToCheckinAndCheckout)(search.stay).checkin
        },
        to: {
          country: search.country,
          prefecture: search.subdivision,
          city: search.city,
          spot: search.spot,
          date: (0, _query.convertStayToCheckinAndCheckout)(search.stay).checkout
        },
        provider: {
          id: params.hotelID ? [params.hotelID] : hotelNos
        },
        guest: {
          adult: search.adults,
          child: search.children
        }
      };
    }),
    price: {
      min: (0, _filters.parsePrice)(search.price).low,
      max: (0, _filters.parsePrice)(search.price).high,
      currency: search.currency
    },
    orderBy: ''
  };
  data.browse = {
    items: params.hotelID ? [{
      provider: {
        id: params.hotelID,
        type: 'hotel'
      }
    }] : hotels.items.map(function (item) {
      return {
        provider: {
          id: item.id,
          type: 'hotel'
        }
      };
    })
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_ThirdPartyTags2.default, {
      loaded: loaded,
      data: data
    })
  );
}

Tracking.propTypes = {
  loaded: _react.PropTypes.bool.isRequired,
  location: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object.isRequired,
  hotels: _react.PropTypes.object.isRequired,
  req: _react.PropTypes.object.isRequired,
  search: _react.PropTypes.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Tracking);


//////////////////
// WEBPACK FOOTER
// ./src/containers/Tracking.js
// module id = 1243
// module chunks = 0